var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_15073",
    "data-name": "Grupo 15073",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.527,
    height: 44.527,
    viewBox: "0 0 44.527 44.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 22.263,
    cy: 22.263,
    r: 22.263,
    fill: "#009bde"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "display_settings_FILL0_wght400_GRAD0_opsz48",
    d: "M87.652-825.392v1.043a.667.667,0,0,0,.209.487.667.667,0,0,0,.487.209.667.667,0,0,0,.487-.209.667.667,0,0,0,.209-.487v-3.478a.667.667,0,0,0-.209-.487.667.667,0,0,0-.487-.209.667.667,0,0,0-.487.209.667.667,0,0,0-.209.487v1.043H86.261a.667.667,0,0,0-.487.209.667.667,0,0,0-.209.487.667.667,0,0,0,.209.487.667.667,0,0,0,.487.209Zm4.174,0h9.739a.667.667,0,0,0,.487-.209.667.667,0,0,0,.209-.487.667.667,0,0,0-.209-.487.667.667,0,0,0-.487-.209H91.826a.667.667,0,0,0-.487.209.667.667,0,0,0-.209.487.667.667,0,0,0,.209.487A.667.667,0,0,0,91.826-825.392Zm8.348-5.565h1.391a.667.667,0,0,0,.487-.209.667.667,0,0,0,.209-.487.668.668,0,0,0-.209-.487.668.668,0,0,0-.487-.209h-1.391v-1.043a.668.668,0,0,0-.209-.487.668.668,0,0,0-.487-.209.668.668,0,0,0-.487.209.668.668,0,0,0-.209.487v3.478a.667.667,0,0,0,.209.487.668.668,0,0,0,.487.209.668.668,0,0,0,.487-.209.667.667,0,0,0,.209-.487Zm-13.913,0H96a.667.667,0,0,0,.487-.209.667.667,0,0,0,.209-.487.668.668,0,0,0-.209-.487.668.668,0,0,0-.487-.209H86.261a.668.668,0,0,0-.487.209.668.668,0,0,0-.209.487.667.667,0,0,0,.209.487A.667.667,0,0,0,86.261-830.957ZM82.087-817.74a2,2,0,0,1-1.461-.626A2,2,0,0,1,80-819.826v-18.087a2,2,0,0,1,.626-1.461A2,2,0,0,1,82.087-840h23.652a2,2,0,0,1,1.461.626,2,2,0,0,1,.626,1.461v18.087a2,2,0,0,1-.626,1.461,2,2,0,0,1-1.461.626H99.13V-816a1.009,1.009,0,0,1-.3.743,1.01,1.01,0,0,1-.743.3H89.739a1.01,1.01,0,0,1-.743-.3,1.009,1.009,0,0,1-.3-.743v-1.739Zm0-2.087h23.652v-18.087H82.087Zm0,0v0Z",
    transform: "translate(-71.65 850.723)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.4e144ac113d90f105e5fdac300f3abb7.svg";
export { ForwardRef as ReactComponent };